import { createContext } from 'react';

export interface PusherContextValue {
  onClear: () => Promise<void>;
  /* Use this for Safari since needs to init on a click handler */
  onInit: () => Promise<void>;
}

export const PusherContext = createContext<PusherContextValue | undefined>(undefined);
